'use strict';
exports.base64 = false;
exports.binary = false;
exports.dir = false;
exports.createFolders = false;
exports.date = null;
exports.compression = null;
exports.comment = null;



//////////////////
// WEBPACK FOOTER
// ./node_modules/jszip/lib/defaults.js
// module id = e3b7
// module chunks = 0